/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AidDto,
  CreateNativeAidRequest,
} from '../models/index';
import {
    AidDtoFromJSON,
    AidDtoToJSON,
    CreateNativeAidRequestFromJSON,
    CreateNativeAidRequestToJSON,
} from '../models/index';

export interface SaveNativeAid2Request {
    createNativeAidRequest: CreateNativeAidRequest;
}

/**
 * 
 */
export class PrivateControllerApi extends runtime.BaseAPI {

    /**
     * Save native AID and start monitoring
     * Save native AID
     * @deprecated
     */
    async saveNativeAid2Raw(requestParameters: SaveNativeAid2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AidDto>> {
        if (requestParameters['createNativeAidRequest'] == null) {
            throw new runtime.RequiredError(
                'createNativeAidRequest',
                'Required parameter "createNativeAidRequest" was null or undefined when calling saveNativeAid2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/agent/.private/aid/native/new`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateNativeAidRequestToJSON(requestParameters['createNativeAidRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AidDtoFromJSON(jsonValue));
    }

    /**
     * Save native AID and start monitoring
     * Save native AID
     * @deprecated
     */
    async saveNativeAid2(requestParameters: SaveNativeAid2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AidDto> {
        const response = await this.saveNativeAid2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
